import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const formattedViews = comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views.toString();

  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden rounded-lg bg-background-200">
        <img
          src={comic.coverImage}
          alt={`${comic.title} 漫画封面`}
          title={`${comic.title} - 丫丫漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-md text-xs font-medium text-white whitespace-nowrap ${
            comic.status === '连载中' ? 'bg-primary-500' : 'bg-foreground-600'
          }`}>
            {comic.status}
          </span>
        </div>
        {comic.rating >= 9.0 && (
          <div className="absolute top-2 right-2 bg-accent-500 text-white text-xs font-bold px-2 py-0.5 rounded-md whitespace-nowrap">
            {comic.rating}
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-white text-xs line-clamp-2 leading-relaxed">{comic.description}</p>
        </div>
      </div>
      <div className="mt-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500">{formattedViews}次阅读</span>
        </div>
        <div className="flex items-center gap-1.5 mt-1.5 flex-wrap">
          {comic.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}